import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const { $ } = window

gsap.registerPlugin(ScrollTrigger)

function portfolio() {
	const filterParams = new URLSearchParams(
		window.location.search.replace('?', '')
	)
	let classArr = []
	const filterSector = filterParams.get('filter-sector')
	const filterStatus = filterParams.get('filter-status')
	const filterSource = filterParams.get('filter-source')
	for (let val of [filterSector, filterStatus, filterSource]) {
		if (val) {
			classArr.push(val)
		}
	}

	// let el = document.querySelector('.projects')
	let qsRegex
	let filterValue = ['', '', '']

	// eslint-disable-next-line no-undef, no-unused-vars
	let $grid = $('.grid').isotope({
		// let iso = new Isotope( el, {
		// options
		itemSelector: '.project',
		layoutMode: 'fitRows',
		// filter: '.initial-value',
		filter: classArr.length ? '.' + classArr.join('.') : '',
		// filter() {
		// 	return filterValue ? $(this).hasClass(filterValue) : true; //! not respecting combinational
		// },

		cellsByRow: {
			columnWidth: 250,
			rowHeight: 150,
		},
		// options for masonry layout mode
		masonry: {
			columnWidth: '.project',
		},
	})

	// bind filter on select change
	let fise = document.getElementById('filter-sector')
	let fiseli = fise.querySelectorAll('li')

	if (fiseli.length) {
		for (i = 0; i < fiseli.length; i++) {
			fiseli[i].addEventListener('click', function () {
				filterValue[0] = this.dataset.value
				if (window.location.search.includes('filter-sector')) {
					history.replaceState(
						{},
						null,
						window.location.pathname +
							window.location.search.replace(
								/(filter-sector=[a-zA-Z\-]*(?=&))/,
								`filter-sector=${this.dataset.value}`
							)
					)
				} else if (window.location.search) {
					history.replaceState(
						{},
						null,
						window.location.pathname +
							window.location.search +
							'&filter-sector=' +
							this.dataset.value
					)
				} else {
					history.replaceState(
						{},
						null,
						window.location.pathname + '?filter-sector=' + this.dataset.value
					)
				}
				document.getElementsByClassName('multiSel')[0].innerHTML =
					this.dataset.name.replaceAll('-', ' ')
				$grid.isotope({
					filter: '.' + filterValue.filter((el) => el.length).join('.'),
				})
			})
		}
	}

	let fist = document.getElementById('filter-status')
	let fistli = fist.querySelectorAll('li')

	if (fistli.length) {
		for (i = 0; i < fistli.length; i++) {
			fistli[i].addEventListener('click', function () {
				filterValue[1] = this.dataset.value
				if (window.location.search.includes('filter-status')) {
					history.replaceState(
						{},
						null,
						window.location.pathname +
							window.location.search.replace(
								/(filter-status=[a-zA-Z\-]*(?=&))/,
								`filter-status=${this.dataset.value}`
							)
					)
				} else if (window.location.search) {
					history.replaceState(
						{},
						null,
						window.location.pathname +
							window.location.search +
							'&filter-status=' +
							this.dataset.value
					)
				} else {
					history.replaceState(
						{},
						null,
						window.location.pathname + '?filter-status=' + this.dataset.value
					)
				}
				document.getElementsByClassName('multiSel')[1].innerHTML =
					this.dataset.name.replaceAll('-', ' ')
				$grid.isotope({
					filter: '.' + filterValue.filter((el) => el.length).join('.'),
				})
			})
		}
	}

	let fistnv = document.getElementById('filter-source')
	let fistnvli = fistnv.querySelectorAll('li')

	if (fistnvli.length) {
		for (i = 0; i < fistnvli.length; i++) {
			fistnvli[i].addEventListener('click', function () {
				filterValue[2] = this.dataset.value
				if (window.location.search.includes('filter-source')) {
					history.replaceState(
						{},
						null,
						window.location.pathname +
							window.location.search.replace(
								/(filter-source=[a-zA-Z\-]*(?=&*))/,
								`filter-source=${this.dataset.value}`
							)
					)
				} else if (window.location.search) {
					history.replaceState(
						{},
						null,
						window.location.pathname +
							window.location.search +
							'&filter-source=' +
							this.dataset.value
					)
				} else {
					history.replaceState(
						{},
						null,
						window.location.pathname + '?filter-source=' + this.dataset.value
					)
				}
				document.getElementsByClassName('multiSel')[2].innerHTML =
					this.dataset.name.replaceAll('-', ' ')
				$grid.isotope({
					filter: '.' + filterValue.filter((el) => el.length).join('.'),
				})
			})
		}
	}

	//pre-filter on page load
	if (filterSector) {
		let selection = document.querySelector(`[data-value=${filterSector}]`)
		if (selection) {
			filterValue[0] = filterSector
			document.getElementsByClassName('multiSel')[0].innerHTML =
				selection.dataset.name.replaceAll('-', ' ')
		}
	}
	if (filterStatus) {
		let selection = document.querySelector(`[data-value=${filterStatus}]`)
		if (selection) {
			filterValue[1] = filterStatus
			document.getElementsByClassName('multiSel')[1].innerHTML =
				selection.dataset.name.replaceAll('-', ' ')
		}
	}
	if (filterSource) {
		let selection = document.querySelector(`[data-value=${filterSource}]`)
		if (selection) {
			filterValue[2] = filterSource
			document.getElementsByClassName('multiSel')[2].innerHTML =
				selection.dataset.name.replaceAll('-', ' ')
			// $grid.isotope({filter: '.'+filterValue.filter(el => el.length).join('.')});
		}
	}
	if (filterValue.filter((el) => el.length).length) {
		$grid.isotope({
			filter: '.' + filterValue.filter((el) => el.length).join('.'),
		})
	}

	// use value of search field to filter
	let $quicksearch = $('#quicksearch').keyup(
		debounce(function () {
			qsRegex = new RegExp($quicksearch.val(), 'gi')
			$grid.isotope()
		})
	)
	// debounce so filtering doesn't happen every millisecond
	function debounce(fn, threshold) {
		let timeout
		return function debounced() {
			if (timeout) {
				clearTimeout(timeout)
			}
			function delayed() {
				fn()
				timeout = null
			}
			setTimeout(delayed, threshold || 100)
		}
	}
}

function trendlines() {
	animateTrendlines()
	function animateTrendlines() {
		if (!$('.trendlines').length) {
			return
		}

		setTimeout(() => {
			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: '.trendlines',
					start: window.matchMedia('(max-width: 700px)').matches
						? 'top 90%'
						: 'center bottom',
					// toggleAction: 'play none none reverse',
					// markers: true
				},
			})

			let d = 0.35
			let settings = {
				opacity: 1,
				duration: d,
				ease: 'power1.out',
				stagger: 0.1,
			}

			gsap.set('.trendlines h2', { x: -32 })
			if ($('.trendlines > p').length) {
				gsap.set('.trendlines > p', { y: 32 })
			}
			// if ($('.trendlines > .btn').length) {
			// 	gsap.set('.trendlines > .btn', {y: -32})
			// }
			gsap.set('.trendline-articles .article-card-wrap', { y: 32 }, `+=${d}`)
			tl.to('.trendlines h2', Object.assign(settings, { x: 0 }))
			if ($('.trendlines > p').length) {
				tl.to('.trendlines > p', Object.assign(settings, { y: 0 }), `-=${d}`)
			}
			if ($('.trendlines > .btn').length) {
				tl.to('.trendlines > .btn', Object.assign(settings, { y: 0 }), `-=${d}`)
			}
			tl.to(
				'.trendline-articles .article-card-wrap',
				Object.assign(settings, { y: 0 }),
				`-=${d}`
			)
		}, 1000)
	}
}

function strategySlider() {
	let $slider = $('.strategy-slider')
	if (!$slider.length) {
		return
	}

	$slider.slick({
		arrows: true,
		prevArrow: $('.ssa--prev'),
		nextArrow: $('.ssa--next'),
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 12000,
		// cssEase: 'ease-out',
		infinite: false,
		dots: true,
		fade: true,
		pauseOnHover: true,
		// responsive: [
		// 	{
		// 		breakpoint: 992,
		// 		settings: {
		// 			adaptiveHeight: true,
		// 			speed: 200
		// 		},
		// 	},
		// ],
		slidesToShow: 1,
		slidesToScroll: 1,
		// speed: 650,
	})

	$slider.find('.slick-slide').each(function () {
		$(this).removeAttr('aria-hidden')
	})

	let $dots = $slider.find('.slick-dots')
	let $slides = $($slider.find('.slick-slide'))
	$slides.find('[class*=content]').prepend($dots)
	$slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		$slides
			.find('[class*=content] .slick-dots .slick-active')
			.removeClass('slick-active')
		//TODO err
		$slides[nextSlide]
			.querySelectorAll(`[class*=content] .slick-dots li`)
			[nextSlide].classList.add('slick-active')
	})

	$slider.on('click', function () {
		$slider.slick('slickNext')
	})
	$slider.find('a').on('click', function (e) {
		e.stopPropagation()
	})
}

function caseStudiesTestimonialsRotator() {
	let $slider = $('.case-studies-testimonials-rotator')
	if (!$slider.length) {
		return
	}

	$slider.slick({
		arrows: true,

		autoplay: false,
		// cssEase: 'ease-out',
		dots: true,
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		// speed: 300,
		prevArrow:
			'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg aria-hidden="true" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.2612 5.94963L15.2612 4.21332L3.93156 4.22201L6.50762 1.53942L5.33214 0.306641L0.738581 5.09016L5.33214 9.87367L6.50762 8.6409L3.93156 5.95831L15.2612 5.94963Z" fill="#A8353A"/> </svg><span class="sr-only">Previous</span></button>',
		nextArrow:
			'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg aria-hidden="true" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.73877 4.23006L0.73877 5.96636L12.0684 5.95768L9.49238 8.64027L10.6679 9.87305L15.2614 5.08953L10.6679 0.306013L9.49238 1.53879L12.0684 4.22138L0.73877 4.23006Z" fill="#A8353A"/> </svg> <span class="sr-only">Next</span></button>',
	})

	let $dots = $slider.find('.slick-dots')
	let $arrows = $slider.find('.slick-arrow')
	// $slider.find('.slick-slide [class*=content]').prepend($dots)
	$slider.remove($dots)
	$slider.parent().find('.cstr-nav-wrap').prepend($dots)
	$slider.remove($arrows)
	$slider.parent().find('.cstr-arrrows-wrap').append($arrows)
}

function caseStudiesTestimonialsCarousel() {
	let $slider = $('.case-studies-testimonials-carousel')
	if (!$slider.length) {
		return
	}

	// let len = $('.case-studies-testimonials-carousel .slick-slide').length

	function CSTCarousel() {
		if (window.matchMedia('(max-width: 600px)').matches) {
			// If media query matches
			$('.case-studies-testimonials-carousel.slick-initialized').slick(
				'unslick'
			)
			let lenLogos = $('.cst-logo').length
			let count = 1
			$('.cst-view-more').on('click', () => {
				$('.cst-logo')
					.slice(0, 6 * ++count)
					.show()
				if (lenLogos <= 6 * count) {
					$('.cst-view-more').hide()
				}
			})
			if (lenLogos <= 6 * count) {
				$('.cst-view-more').hide()
			} else {
				$('.cst-logo').slice(6).hide()
			}
		} else {
			$('.cst-logo').show()
			$('.case-studies-testimonials-carousel:not(.slick-initialized)').slick({
				arrows: false,

				autoplay: true,
				autoplaySpeed: 3500,
				// cssEase: 'ease-out',
				dots: false,
				slidesToShow: 5, //Math.min(5, len),
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 1400,
						settings: {
							slidesToShow: 4,
						},
					},
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
						},
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
					{
						breakpoint: 390,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			})
		}
	}

	//  var x = window.matchMedia("(max-width: 600px)")
	CSTCarousel() // Call listener function at run time
	//  x.addListener(CSTCarousel) // Attach listener function on state changes
	window.onresize = CSTCarousel
}

export {
	caseStudiesTestimonialsRotator,
	caseStudiesTestimonialsCarousel,
	strategySlider,
	portfolio,
	trendlines,
}
